import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "https://lead-tracker-backend-gyoa.onrender.com/api";

export const trackVisit = async ({ clientId, pageUrl }) => {
  try {
    await axios.post(`${API_BASE}/analytics`, {
      clientId,
      pageUrl,
      referrer: document.referrer || null,
      userAgent: navigator.userAgent,
      ip: null // optional, backend can detect real IP if needed
    });
  } catch (error) {
    console.error("Analytics tracking failed:", error.message);
  }
};
